import { Building2 } from "lucide-react";

/**
 * Compact PRO badge displayed next to user names across the app
 * whenever profile_type === "professional".
 *
 * Distinct from Verified (blue check), Creator (crown), Golden Ring (gold ring).
 * Kept intentionally small so it fits inline in dense list rows.
 */
export function ProBadge({ user, size = "sm", showLabel = true, className = "" }) {
  if (!user || user.profile_type !== "professional") return null;
  const isXs = size === "xs";
  return (
    <span
      title="ADE Pro"
      className={
        `inline-flex items-center gap-0.5 rounded-md font-semibold text-blue-700 bg-blue-50 border border-blue-200 ` +
        (isXs ? "px-1 py-0 text-[9px]" : "px-1.5 py-0.5 text-[10px]") + " " + className
      }
      data-testid="pro-badge-inline"
    >
      <Building2 className={isXs ? "w-2 h-2" : "w-2.5 h-2.5"} />
      {showLabel && <span>PRO</span>}
    </span>
  );
}
